import axios from "axios";

export default axios.create({
    baseURL: 'https://modena.monte360.com/investor/insertInvestment.php',
    headers: {
        "Content-Type": "application/json",
} 
});
